// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604210759/js/" + chunkId + "." + {"44":"19fdc70d","225":"6bc87fb0","481":"7676acb5","486":"a0defd50","770":"2e7e44f4"}[chunkId] + ".0.7683615942888034.chunk.js";
};